import React from "react";
import { SiReact } from "react-icons/si";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";

const workData = [
  {
    date: "Nov 2024 – Jul 2025",
    company: "BangHome",
    title: "Software Engineering & Full Stack Developer Intern",
    location: "Bengaluru, Karnataka (Remote)",
    color: "#f29f67",
    points: [
      "Designed and deployed a rental operations platform handling 100K+ monthly requests using Next.js, TypeScript, Docker, AWS EC2, and REST APIs.",
      "Achieved 99.9% uptime through scalable system design, CI/CD automation, and optimized deployment.",
      "Developed AWS Lambda pipelines to automate processing of S3 data uploads.",
      "Migrated database from MongoDB to PostgreSQL; improved performance by 40% for 2K–3K daily records.",
      "Reduced load time from 3s → 0.5s and improved Lighthouse score from 30 → 80.",
      "Integrated AI-based chatbot and recommendation features to increase user engagement.",
      "Built a PWA for the website, boosting SEO and enhancing mobile accessibility.",
    ],
  },
  {
    date: "Jul 2025 – Present",
    company: "Sarthi.me",
    title: "Full Stack Development Intern",
    location: "Noida, Uttar Pradesh (Hybrid)",
    color: "#3b8ff3",
    points: [
      "Delivered end-to-end feature development for 10K+ active users using React.js, TypeScript, Node.js, and Redux.",
      "Improved frontend performance by 50% using lazy loading, memoization, and efficient state management.",
      "Built and deployed FastAPI-based backend services handling 5K+ daily requests.",
      "Optimized PostgreSQL schemas and queries, reducing average response time by 40%.",
      "Integrated Mixpanel analytics to track user behavior and drive product improvements.",
    ],
  },
  {
    date: "Oct 2025 – Present",
    company: "CreditSea",
    title: "Associate Software Engineer",
    location: "Fintech Platform (Raipur, Chhattisgarh)",
    color: "#10b981",
    points: [
      "Developed a secure document management system for LOS and LMS modules serving 150K+ users.",
      "Improved backend efficiency by eliminating 40% redundant API calls with asynchronous loaders.",
      "Designed advanced filtering and search mechanisms, reducing query response time by 35%.",
      "Built a ticketing system to manage technical, customer support, and legal issues independently.",
    ],
  },
];

const WorkExp = () => {
  return (
    <section
      id="work"
      className="py-20 px-4 bg-gradient-to-br from-blue-50 to-indigo-50
        dark:from-[#0a0a18] dark:to-[#0f0f1a] transition-colors duration-300"
    >
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-14">
          <h2
            className="text-3xl font-extrabold uppercase tracking-widest
              text-gray-800 dark:text-white mb-3"
            style={{ fontFamily: "'Syne', sans-serif" }}
          >
            Work Experience
          </h2>
          <div className="w-16 h-1 mx-auto rounded-full bg-gradient-to-r from-[#f29f67] to-[#3b8ff3]" />
        </div>

        <VerticalTimeline lineColor="rgba(242,159,103,0.3)">
          {workData.map((job, idx) => (
            <VerticalTimelineElement
              key={idx}
              className="vertical-timeline-element--work"
              contentStyle={{
                background: "rgba(255,255,255,0.95)",
                color: "#1e293b",
                borderRadius: "16px",
                boxShadow: "0 4px 24px rgba(0,0,0,0.07)",
                border: `1px solid ${job.color}22`,
              }}
              contentArrowStyle={{ borderRight: `7px solid rgba(255,255,255,0.95)` }}
              date={
                <span className="text-sm font-semibold" style={{ color: job.color }}>
                  {job.date}
                </span>
              }
              iconStyle={{
                background: job.color,
                color: "#fff",
                boxShadow: `0 0 0 4px ${job.color}33`,
              }}
              icon={<SiReact />}
            >
              <div className="flex items-start justify-between flex-wrap gap-2">
                <div>
                  <h3
                    className="font-bold text-base text-gray-900"
                    style={{ fontFamily: "'Syne', sans-serif" }}
                  >
                    {job.title}
                  </h3>
                  <h4 className="text-sm font-bold mt-0.5" style={{ color: job.color }}>
                    {job.company}
                  </h4>
                  <p className="text-xs text-gray-400 mt-0.5">{job.location}</p>
                </div>
              </div>
              <ul className="mt-3 space-y-1.5">
                {job.points.map((point, i) => (
                  <li key={i} className="flex gap-2 text-sm text-gray-600">
                    <span className="mt-1.5 w-1.5 h-1.5 rounded-full flex-shrink-0"
                      style={{ background: job.color }} />
                    {point}
                  </li>
                ))}
              </ul>
            </VerticalTimelineElement>
          ))}
        </VerticalTimeline>
      </div>
    </section>
  );
};

export default WorkExp;